import { BullpenGroup } from "./BullpenGroup";
import { TubSheetStore } from "stores/TubSheetStore";
import { observable } from "mobx";

export class TubSheet extends BullpenGroup {
  static _store: TubSheetStore;

  @observable upcoming_tare_weight?: string;
}
